import {Component, inject, input, model, output, signal} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions, MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LockReasons } from 'src/app/models/integration';

@Component({
  selector: 'app-integration-lock',
  imports: [
    CommonModule,
    MatCheckboxModule,
  ],
  templateUrl: './integration-lock.component.html',
  styleUrl: './integration-lock.component.scss',
  providers: [
    {provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { clickAction: 'noop' } as MatCheckboxDefaultOptions},
  ],
})
export class IntegrationLockComponent{
  locked = input.required<boolean>();
  lockReason = input<string>('');
  disabled = input.required<boolean>();
  displayAsCheckbox = input<boolean>(false);
  lockReasonSubmitted = output<string>();
  //locked = signal<boolean>(false);
  //lockReason = signal<string>('');
  dialog = inject(MatDialog);

  openDialog(): void {

    //If unlocking
    if (this.locked())
    {
      //this.locked.set(!this.locked());
      this.lockReasonSubmitted.emit(null);
      return;
    }

    //If locking
    var dialogRef = this.dialog.open(IntegrationLockDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        this.lockReasonSubmitted.emit(result);
      }
    });
  }
}

@Component({
  selector: 'app-integration-lock-dialog',
  templateUrl: './integration-lock-dialog.html',
  styleUrl: './integration-lock.component.scss',
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
})
export class IntegrationLockDialogComponent {
  readonly dialogRef = inject(MatDialogRef<IntegrationLockDialogComponent>);

  readonly selectedLockReason = model('');

  readonly customLockReason = model('');
  customLockReasonSelected = signal<boolean>(false);
  readonly lockReasonPresets: string[] = LockReasons;

  onLockReasonChange(event: any): void {
    this.customLockReasonSelected.set(event.value == 'Custom');
  }

  getLockReason(): string {
    var lockReason = '';

    if (this.customLockReasonSelected())
    {
      lockReason = 'CUST: ' + this.customLockReason();
    }
    else
    {
      lockReason = this.selectedLockReason();
    }
    
    return lockReason;
  }
}